<template>
  <div>
    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fs">
      <builderall-icon code='arrow-left' class="ba-color-blue1" @click="$emit('setComponent', 'VoteList')" style="cursor: pointer;"></builderall-icon>
      <div class="ba-w-100 ba-flex ba-jc-center">
        <span class="ba-montserrat-600">{{ quest.description }}</span>
      </div>
    </div>
    <!-- <h2>{{ $t("ct-vote-quest") + ": " + quest.description }}</h2 -->
    <div class="ba-card ba-blue ba-no-shadow ba-w-100">
      <div class="ba-w-100 ba-grid" v-for="(option, index) in options" :key="index">
        <div class="ba-w-100 ba-flex ba-ai-center ba-gp-06">
          <div class="ba-grid ba-w-100">
            <label>{{ $t("ct-option") }} <strong> {{ (index + 1) }} </strong> | votes : <strong> {{
            parseInt(option.count_votes) }} </strong> </label>
               <input required type="text" class="ba-input ba-w-100" :placeholder="$t('ct-vote-enter-your-answer')"
               v-model="options[index].answers" />
          </div>
          <i class="svg-icon svgi-plus" style="cursor: pointer;" @click="addOption()"></i>
          <button v-if="index !== 0" class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="removeOption(index)">
            <builderall-icon code='trash' />
          </button>
          <div v-else style="width: 30px;">
          </div>
        </div>
      </div>
      <hr class="ba-hr-row hr" />
      <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
        <button class="ba-btn ba-blue ba-md" @click.prevent="save">
          {{ $t("ct-save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { update as updateQuestion, getOne } from "../../../js/services/editor/votesystem";


export default {
  name: "VoteEdit",
  props: ['vote_id'],
  data() {
    return {
      quest: {
        description: '',
        id: null
      },
      total: 0,
      options: [],
    };
  },

  methods: {
    save() {
      if (!this.validate()) {
        this.$snotify.error(this.$t(`ct-invalid`));
        return
      }

      updateQuestion(this.quest, this.options)
        .then(res => {
          this.$snotify.success(this.$t(`ct-success-true`));
        })
    },

    removeOption(index) {
      this.options.splice(index, 1);
    },

    get() {
      getOne(this.vote_id)
        .then(response => {
          this.quest = response.data
          if (this.quest.options.length) {
            this.quest.options.forEach(option => {
              this.options.push({
                answers: option.description,
                count_votes: option.count_votes,
              });
              this.total += option.count_votes
            })
          } else {
            this.addOption()
          }

        })
    },

    validate() {
      let valid = true;
      this.options.forEach(option => {
        if (option.answers === "") {
          valid = false
        }
      })
      return valid;
    },

    addOption() {
      this.options.push({
        answers: "",
        count_votes: 0,
      });
    },
  },

  created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/VoteEdit.vue